import { APPLE_COMMAND_KEY } from './constants';
/**
 * The french translations.
 */
export const fr = {
    gestureHandlingTouch: 'Utilisez deux doigts pour déplacer la carte',
    gestureHandlingScroll: "Vous pouvez zoomer sur la carte à l'aide de CTRL + Molette de défilement",
    gestureHandlingScrollMac: `Vous pouvez zoomer sur la carte à l'aide de ${APPLE_COMMAND_KEY} + Molette de défilement`,
    Transparency: 'Transparence',
};
//# sourceMappingURL=fr.js.map